function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { debounce } from "../../util/dom";
import { addToBag, addBundleToBag, updateKlarna } from "../../shop/connect";
import { update } from "../../shop/render";
import { trackAddToCart, checkCartItemDetails } from "../stoked";
var defaultPreviewText = '&nbsp;';
var SystemBundle = {
  isBundle: document.body.classList.contains("single-bundle")
};
SystemBundle.isMobile = function () {
  return matchMedia("screen and (max-width: 991px)").matches;
};
SystemBundle.pickerToggle = function () {
  var toggleButton = document.querySelectorAll("input.js-system-bundle-toggle");
  if (toggleButton.length === 0) {
    return;
  }
  toggleButton.forEach(function (item) {
    item.addEventListener("click", function (event) {
      var target = event.target;
      var item = target.closest(".system-bundle-list-item");
      if (target.dataset.isOneSize === "true" || target.dataset.isOneColor === "true") {
        return;
      }
      if (target.classList.contains("is-size")) {
        item.classList.add("is-active", "is-size");
        item.classList.remove("is-color");
        target.classList.remove("no-size-selected");
      } else if (target.classList.contains("is-color")) {
        item.classList.add("is-active", "is-color");
        item.classList.remove("is-size");
      }
    });
  });
};
SystemBundle.pickerToggleText = function () {
  var toggleText = document.querySelectorAll(".js-system-bundle-toggle-text, .js-system-bundle-toggle-color-text");
  if (toggleText.length === 0) {
    return;
  }
  toggleText.forEach(function (item) {
    var input = item.parentElement.querySelector("input");
    if (input.dataset.isOneSize === "true" || input.dataset.isOneColor === "true") {
      item.innerHTML = item.dataset.mobileText || defaultPreviewText;
      return;
    } else if (input.dataset.noColor === "true") {
      item.innerHTML = defaultPreviewText;
      return;
    }
    if (SystemBundle.isMobile()) {
      item.innerHTML = item.dataset.mobileText || defaultPreviewText;
    } else {
      item.innerHTML = item.dataset.text || defaultPreviewText;
    }
  });
};
SystemBundle.colorSelect = function () {
  var colors = document.querySelectorAll("input.js-system-bundle-select-color");
  if (colors.length === 0) {
    return;
  }
  colors.forEach(function (item) {
    item.addEventListener("click", function (event) {
      if (!event.target.checked) {
        return;
      }
      var parent = event.target.closest(".system-bundle-list-item"),
        label = parent.querySelector(".js-system-bundle-selected-color"),
        items = parent.querySelectorAll("li.js-system-bundle-select-size-item"),
        labelText = parent.querySelector(".js-system-bundle-selected-size"),
        toggleText = parent.querySelector(".js-system-bundle-toggle-color-text");
      parent.classList.remove("is-active", "is-color");
      var selectedColor = event.target.dataset.label;
      var labelTextValue = SystemBundle.isMobile() ? toggleText.dataset.mobileText : selectedColor;
      toggleText.innerHTML = labelTextValue || defaultPreviewText;
      toggleText.dataset.text = selectedColor;
      if (event.target.dataset.color) {
        label.style.backgroundColor = event.target.dataset.color;
      } else if (event.target.dataset.colorImage) {
        label.style.backgroundImage = "url(".concat(event.target.dataset.colorImage, ")");
      }
      parent.querySelector(".js-section-link").href = event.target.dataset.url;
      parent.querySelector(".js-section-image").src = event.target.dataset.image;
      var selectedSizeText = labelText.innerText;
      labelText.innerText = "";
      items.forEach(function (item) {
        var input = item.querySelector("input");
        if (item.dataset.product === event.target.value) {
          item.classList.remove("d-none");
          if (selectedSizeText === input.dataset.label && input.disabled === false) {
            labelText.innerText = input.dataset.label;
            input.checked = true;
          } else {
            input.checked = false;
          }
        } else {
          item.classList.add("d-none");
          input.checked = false;
        }
      });
      SystemBundle.checkSoldout();
      SystemBundle.checkOneSize();
      SystemBundle.removeErrors(event.target);
    });
  });
};
SystemBundle.removeErrors = function (element) {
  var buttonText, error;
  if (SystemBundle.isBundle) {
    buttonText = document.querySelector(".js-button-text");
    error = element.closest(".system-bundle-list-item").querySelector(".no-size-selected");
  } else {
    var form = element.closest("form.systemProductAddToCartForm");
    buttonText = form.querySelector(".js-button-text");
    error = form.querySelector(".no-size-selected");
  }
  buttonText.innerText = buttonText.dataset.text;
  if (error) {
    error.classList.remove("no-size-selected");
  }
};
SystemBundle.sizeSelect = function () {
  var sizes = document.querySelectorAll("input.js-system-bundle-select-size");
  if (sizes.length === 0) {
    return;
  }
  sizes.forEach(function (item) {
    item.addEventListener("click", function (event) {
      if (!event.target.checked) {
        return;
      }
      var parent = event.target.closest(".system-bundle-list-item"),
        label = parent.querySelector(".js-system-bundle-selected-size"),
        toggleText = parent.querySelector(".js-system-bundle-toggle-text");
      parent.classList.remove("is-active", "is-size");
      label.innerText = event.target.dataset.label;
      toggleText.innerText = toggleText.dataset.mobileText;
      toggleText.dataset.text = toggleText.dataset.mobileText;
      var checkboxParent = event.target.closest(".custom-control.custom-checkbox"),
        selectedCheckboxParent = label.closest(".custom-control.custom-checkbox");
      selectedCheckboxParent.className = checkboxParent.className;
      SystemBundle.removeErrors(event.target);
    });
  });
};
SystemBundle.addBundleToCartForm = function () {
  var form = document.getElementById("bundleAddToCartForm"),
    buttonText = form.querySelector(".js-button-text"),
    button = form.querySelector("button[type=submit]");
  form.addEventListener("submit", function (event) {
    event.preventDefault();
    var formData = new FormData(event.target),
      sections = [];
    var _iterator = _createForOfIteratorHelper(formData.entries()),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          _ = _step$value[1];
        if (key.indexOf("section|") !== -1) {
          sections.push({
            section: key.split("|")[1],
            item: null
          });
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    var hasError = false;
    sections.forEach(function (section, index) {
      var input = document.getElementById("sizeSelected".concat(section.section));
      if (formData.get(section.section)) {
        input.classList.remove("no-size-selected");
        sections[index].item = formData.get(section.section);
      } else {
        input.classList.add("no-size-selected");
        hasError = true;
      }
    });
    if (hasError) {
      buttonText.innerText = buttonText.dataset.error;
      return;
    }
    buttonText.innerText = buttonText.dataset.text;
    button.classList.add("is-loading");
    var itemToAdd = formData.get("item");
    addBundleToBag(itemToAdd, sections).then(function () {
      button.classList.remove("is-loading");
      showCart();
      var _checkCartItemDetails = checkCartItemDetails(itemToAdd, sections),
        line = _checkCartItemDetails.line,
        isLatestItemInSelection = _checkCartItemDetails.isLatestItemInSelection;
      $.event.trigger("stoked-add-to-cart", [line, 1, isLatestItemInSelection, trackAddToCart]);
    }).catch(function (err) {
      return console.log("DEBUG: err", err);
    });
  });
};
SystemBundle.addSystemProductToCartForm = function () {
  var forms = document.querySelectorAll("form.systemProductAddToCartForm");
  forms.forEach(function (form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var buttonText = form.querySelector(".js-button-text"),
        button = form.querySelector("button[type=submit]");
      var formData = new FormData(event.target);
      if (!formData.has("item")) {
        buttonText.innerText = buttonText.dataset.error;
        form.querySelector("input.js-system-bundle-toggle.is-size").classList.add("no-size-selected");
        return;
      }
      buttonText.innerText = buttonText.dataset.text;
      button.classList.add("is-loading");
      var itemToAdd = formData.get("item");
      addToBag(itemToAdd).then(function () {
        buttonText.innerText = button.dataset.added;
        button.classList.remove("is-loading");
        button.classList.add("in-cart");
        showCart();
        var _checkCartItemDetails2 = checkCartItemDetails(itemToAdd),
          line = _checkCartItemDetails2.line,
          isLatestItemInSelection = _checkCartItemDetails2.isLatestItemInSelection;
        $.event.trigger("stoked-add-to-cart", [line, 1, isLatestItemInSelection, trackAddToCart]);
      }).catch(function (err) {
        return console.log("DEBUG: err", err);
      });
    });
  });
};
var showCart = function showCart() {
  var showCartOverlay = $("#js-checkout").length === 0;
  var cartContainer = $(".js-cart-overlay");
  var body = $("body");
  if (window.CentraCheckout) {
    updateKlarna();
  }
  if (showCartOverlay) {
    cartContainer.addClass("is-open");
    body.addClass("cart-overlay");
  } else {
    // Checkout add ons - this is to fix Safari scrollTo top when an element is added in the cart
    var postScrollOffset = $(document).scrollTop();
    if (preScrollOffset && postScrollOffset && preScrollOffset === postScrollOffset) {
      var postScrollHeight = $(document).height();
      var deltaHeight = postScrollHeight - preScrollHeight;
      $("html, body").animate({
        scrollTop: postScrollOffset + deltaHeight
      }, 1);
    }
  }
  setTimeout(function () {
    if (showCartOverlay) {
      cartContainer.removeClass("is-open");
      body.removeClass("cart-overlay");
    }
    update();
  }, 2500);
};
SystemBundle.checkSoldout = function () {
  var selections = document.querySelectorAll("ul.size-selector--toggle,ul.color-selector--toggle");
  selections.forEach(function (selection) {
    var parent = selection.closest(".system-bundle-list-item"),
      selector = parent.querySelector(selection.classList.contains("size-selector") ? "ul.js-size-selector" : "ul.js-color-selector"),
      selected = selection.querySelector("input"),
      enabledItems = selector.querySelectorAll("li:not(.d-none) input"),
      disabledItems = selector.querySelectorAll("li:not(.d-none) input[disabled]");
    selected.disabled = enabledItems.length === disabledItems.length || selected.dataset.noColor === "true";
  });
};
SystemBundle.checkOneSize = function () {
  var items = document.querySelectorAll(".system-bundle-list-item");
  items.forEach(function (item) {
    var sizes = item.querySelectorAll("ul.js-size-selector li:not(.d-none) input.js-system-bundle-select-size");
    if (sizes.length > 1) {
      item.querySelector("input.js-system-bundle-toggle.is-size").dataset.isOneSize = false;
      return;
    }
    var option = sizes[0],
      parent = option.closest(".system-bundle-list-item"),
      checkbox = parent.querySelector("input.js-system-bundle-toggle.is-size"),
      label = parent.querySelector(".js-system-bundle-selected-size");
    option.checked = true;
    checkbox.checked = true;
    checkbox.dataset.isOneSize = true;
    label.innerText = option.dataset.label;
    if (SystemBundle.isBundle) {
      var buttonText = document.getElementById("bundleAddToCartForm").querySelector(".js-button-text");
      buttonText.innerText = buttonText.dataset.text;
    }
    var checkboxParent = option.closest(".custom-control.custom-checkbox"),
      selectedCheckboxParent = label.closest(".custom-control.custom-checkbox");
    selectedCheckboxParent.className = checkboxParent.className;
  });
};
window.addEventListener("resize", debounce(function () {
  SystemBundle.pickerToggleText();
}, 200));
SystemBundle.pickerToggle();
SystemBundle.colorSelect();
SystemBundle.sizeSelect();
SystemBundle.checkSoldout();
SystemBundle.checkOneSize();
SystemBundle.pickerToggleText();
if (SystemBundle.isBundle) {
  SystemBundle.addBundleToCartForm();
} else {
  SystemBundle.addSystemProductToCartForm();
}
window.SystemBundle = SystemBundle;


// WEBPACK FOOTER //
// ./scripts/components/sliders/system-bundle.js